import React, { useEffect, useRef, useState } from 'react';
import { motion, AnimateSharedLayout, useScroll, useTransform } from 'framer-motion';
import './HomeScreen.css';
import Header from '../header/Header';

import pluginRefract from '../assets/RefractPromoImg3.jpg'
import pluginDuck from '../assets/DuckProduct2.jpg'

import BagIconWhite from '../assets/CartBagWhite.svg'
import { ReactSVG } from 'react-svg'

import bgVideoTest from '../assets/LandingPageTestVid2.mp4'

import { useNavigate } from 'react-router-dom';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase';
import CookieConsent from '../components/CookieConsent';


const HomeScreen = () => {
    const [selected, setSelected] = useState('aurora');

    const [scrolled, setScrolled] = useState(false);
    const scrollContainer = useRef(null);
    const scrolledContentRef = useRef(null);
    const containerRef = useRef(null);

    const navigate = useNavigate();

    const { scrollYProgress } = useScroll({ container: containerRef });
    const blurTransform = useTransform(scrollYProgress, [0, 0.3, 1], ["blur(0px) brightness(1) saturate(1)", "blur(12px) brightness(0.4) saturate(0.8)", "blur(30px) brightness(0.15) saturate(0.5)"]);
    const scaleTransform = useTransform(scrollYProgress, [0, 1], [1, 1.15]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) {
                        setScrolled(true);
                        setSelected('about aurora');
                    } else {
                        setScrolled(false);
                        setSelected('aurora');
                    }
                });
            },
            { threshold: 0 }
        );

        if (scrollContainer.current) {
            observer.observe(scrollContainer.current);
        }

        return () => {
            if (scrollContainer.current) {
                observer.unobserve(scrollContainer.current);
            }
        };
    }, []);

    const [clickedItem, setClickedItem] = useState('');

    const MenuItem = ({ text, onClick }) => {
        const isSelected =
            text.toLowerCase() === selected || text.toLowerCase() === clickedItem;
        return (
            <motion.div
                layout
                className={`menu-item ${isSelected ? 'selected' : ''}`}
                onClick={() => onClick(text.toLowerCase())}
            >
                <div className='menu-item-title'>
                    {text}
                </div>
            </motion.div>
        );
    };

    const handleMenuClick = (text) => {
        setClickedItem(text);
        if (text === 'about aurora' && scrolledContentRef.current) {
            scrolledContentRef.current.scrollIntoView({ behavior: 'smooth' });
        } else if (text === 'aurora' && scrollContainer.current) {
            scrollContainer.current.scrollIntoView({ behavior: 'smooth' });
        }
    };


    return (
        <div className="home-screen" ref={containerRef}>

            <motion.video
                className='home-video'
                src={bgVideoTest}
                autoPlay={true}
                loop={true}
                muted={true}
                playsInline={true}
                style={{ filter: blurTransform, scale: scaleTransform }}
            />

            <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 9999 }}>
                <div className="home-blurry"></div>
                <Header page="home" />
            </div>
            
            {/* Section 0: The Hero Video Overlay */}
            <div className="snap-section" ref={scrollContainer}>
                <div className="content-container" style={{ minHeight: '100vh', marginTop: 0, width: '100%' }}>
                    <div className="left-column">
                        <motion.div
                            initial={{ opacity: 0, scale: 0.7 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: false }}
                            transition={{ delay: 0.0 }}
                            className="home-title">
                            Aurora
                        </motion.div>
                        <motion.div
                            className="home-info"
                            initial={{ opacity: 0, scale: 0.7 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: false }}
                            transition={{ delay: 0.1 }}
                        >
                            A new tape style delay from Tape Signal.
                            A one of a kind feedback eq that sparks new life into every sound you put through it.
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0, scale: 0.7 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: false }}
                            transition={{ delay: 0.2 }}>
                            <button className="shop-now-btn"
                                onClick={() => {
                                    navigate('/products');
                                    logEvent(analytics, "Home_Screen_Shop_Now")
                                }}
                            >
                                <ReactSVG src={BagIconWhite} />
                                <motion.div>Shop now</motion.div>
                            </button>
                        </motion.div>
                    </div>

                    <motion.div 
                        className="refract-home-banner" 
                        initial={{ x: 100, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        onClick={() => {
                            logEvent(analytics, "Home_Refract_Banner_Click");
                            navigate('/refract');
                        }}
                    >
                        <div className="refract-home-banner-badge">NEW RELEASE & 40% SALE!</div>
                        <div className="refract-home-banner-title">Refract is here</div>
                        <div className="refract-home-banner-desc">
                            A revolutionary multiband processor. Turn any plugin into a multiband powerhouse.
                        </div>
                        <div className="refract-home-banner-link">Discover Refract &rarr;</div>
                    </motion.div>
                </div>
            </div>

            {/* Section 2: Refract Showcase */}
            <div className="snap-section">
                <motion.div 
                    className="home-product-section premium-glass-card"
                    initial={{ opacity: 0, y: 100 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.4 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                >
                    <div className="home-product-image-container float-anim">
                        <img src={pluginRefract} alt="Refract" className="home-product-image" />
                    </div>
                    <div className="home-product-copy">
                        <div className="home-product-badge">New Release</div>
                        <div className="home-product-title">Refract</div>
                        <div className="home-product-desc">
                            A revolutionary multiband processor. Break down any audio signal and apply your favorite third-party VST3 or AU plugins to specific isolated frequency bands.
                        </div>
                        <button className="home-cta-button" onClick={() => {
                            logEvent(analytics, "Home_Scroll_Refract");
                            navigate('/refract');
                        }}>
                            Discover Refract
                        </button>
                    </div>
                </motion.div>
            </div>

            {/* Section 3: Duck Showcase */}
            <div className="snap-section">
                <motion.div 
                    className="home-product-section reverse premium-glass-card"
                    initial={{ opacity: 0, y: 100 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.4 }}
                    transition={{ duration: 0.8, ease: "easeOut", delay: 0.1 }}
                >
                    <div className="home-product-image-container float-anim-reverse">
                        <img src={pluginDuck} alt="Duck" className="home-product-image" />
                    </div>
                    <div className="home-product-copy" style={{ alignItems: 'flex-start' }}>
                        <div className="home-product-badge">What the duck</div>
                        <div className="home-product-title">Duck</div>
                        <div className="home-product-desc">
                            Duck is a plugin host that can house all your favorite reverb, delay, and spatial effects plugins, making it simple to duck the effect perfectly against your dry signal. Unparalleled dynamic space in seconds.
                        </div>
                        <button className="home-cta-button" onClick={() => {
                            logEvent(analytics, "Home_Scroll_Duck");
                            navigate('/duck');
                        }}>
                            Discover Duck
                        </button>
                    </div>
                </motion.div>
            </div>

            {/* Section 4: Soundbird Teaser */}
            <div className="snap-section">
                <motion.div 
                    className="home-soundbird-teaser"
                    initial={{ opacity: 0, scale: 0.8 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: false, amount: 0.5 }}
                    transition={{ duration: 1.5, ease: "easeOut" }}
                >
                    <motion.div 
                        className="home-soundbird-title" 
                        initial={{ filter: "blur(15px)", opacity: 0.4 }}
                        whileInView={{ filter: "blur(0px)", opacity: 1 }}
                        viewport={{ once: false, amount: 0.8 }}
                        transition={{ duration: 1.8, ease: "easeOut" }}
                    >
                        A big announcement incoming.
                    </motion.div>
                    
                    <div className="home-soundbird-links">
                        <span onClick={() => navigate('/terms')}>Terms</span>
                        <span onClick={() => navigate('/contact')}>Contact</span>
                        <span onClick={() => navigate('/cookiepolicy')}>Cookie Policy</span>
                        <span onClick={() => navigate('/privacypolicy')}>Privacy Policy</span>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default HomeScreen;
